export default "__VITE_ASSET__CZZeYSDi__"